import { supabase } from '../supabaseClient'
import { ROLES } from '../constants'

export function normalizePhone(phone) {
  if (!phone) return ''
  let clean = phone.trim().replace(/[\s\-()]/g, '')
  if (!clean.startsWith('+')) {
    if (clean.startsWith('0')) {
      clean = '+58' + clean.slice(1)
    } else if (clean.startsWith('58')) {
      clean = '+' + clean
    } else if (/^\d{10}$/.test(clean)) {
      clean = '+58' + clean
    } else {
      clean = '+' + clean
    }
  }
  return clean
}

export async function registerUser({ email, phone, password, name, role }) {
  const formattedPhone = phone ? normalizePhone(phone) : undefined
  const metadata = { name, role: role || ROLES.PASSENGER, phone: formattedPhone || null }
  const options = { data: metadata }

  const signUpOptions = email
    ? { email: email.trim(), password, options }
    : { phone: formattedPhone, password, options }

  const { data, error } = await supabase.auth.signUp(signUpOptions)

  if (error) {
    throw new Error(error.message || 'Error al registrar usuario')
  }

  return { success: true, user: data.user, session: data.session, user_id: data.user?.id }
}

export function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export function validatePhone(phone) {
  const norm = normalizePhone(phone)
  return /^\+[1-9]\d{6,14}$/.test(norm)
}

export function validatePassword(password) {
  const errors = []
  if (password.length < 8) errors.push('Al menos 8 caracteres')
  if (!/[A-Z]/.test(password)) errors.push('Una mayúscula')
  if (!/[0-9]/.test(password)) errors.push('Un número')
  return errors
}

export function getPasswordStrength(password) {
  let score = 0
  if (password.length >= 8) score++
  if (password.length >= 12) score++
  if (/[A-Z]/.test(password)) score++
  if (/[0-9]/.test(password)) score++
  if (/[^A-Za-z0-9]/.test(password)) score++
  if (score <= 2) return { label: 'Débil', color: '#dc3545', width: '33%' }
  if (score <= 4) return { label: 'Media', color: '#ffc107', width: '66%' }
  return { label: 'Fuerte', color: '#00C853', width: '100%' }
}

export function detectIdentifierType(value) {
  if (!value) return null
  if (value.includes('@')) return 'email'
  if (/^[\d\s\-+()]+$/.test(value.trim()) && value.replace(/[\s\-+()]/g, '').length >= 7) return 'phone'
  return 'unknown'
}

export async function signInWithIdentifier(identifier, password) {
  const type = detectIdentifierType(identifier)
  if (type === 'email') {
    return supabase.auth.signInWithPassword({ email: identifier.trim(), password })
  } else if (type === 'phone') {
    const cleanPhone = normalizePhone(identifier)
    return supabase.auth.signInWithPassword({ phone: cleanPhone, password })
  } else {
    throw new Error('Ingresa un correo electrónico o número de teléfono válido')
  }
}
